<template>
  <el-drawer
    v-if="visible"
    :visible="visible"
    :title="$l('drawer_title_synchronize_order') || '销售渠道订单查询'"
    show-close
    top="10vh"
    :size="1000"
    direction="rtl"
    @close="close"
    :close-on-click-modal="false"
    :wrapper-closable="false"
    :modal-append-to-body="false"
    :modal="true"
  >
    <Main
      class="ml-4 mr-4"
      ref="main"
      @checkboxChange="checkboxChange"
      @reload="$emit('reload')"
      @close="close()"
    />
    <div
      class="ml-4 mr-4"
      style="display: flex;justify-content: flex-end;margin-top: 10px;margin-bottom: 10px;"
    >
      <el-button size="small" class="mr-4" @click="close()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
        class="item"
      >
        <el-button
          type="primary"
          size="small"
          :disabled="!checkedRowCount"
          @click="confirm()"
        >
          {{ $l('INDEX.btn_confirm') || '确定' }}
        </el-button>
      </el-badge>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      checkList: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkList?.length || 0
    },
  },
  methods: {
    close() {
      this.checkList = []
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    checkboxChange(data) {
      this.checkList = data
    },
    confirm() {
      this.$refs.main.sync(this.checkList)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-drawer__header {
    margin-bottom: 0px !important ;
  }
}
</style>
